import React from "react";
import { connect } from "react-redux";
import { bool, func, number, object, string } from "prop-types";
import PolygonPrototype from "../Polygon";
import { updatePolygon } from "redux/polygon/actions";
import { selectUserRole } from "redux/permission/selector";

function Polygon({
  properties,
  ratio,
  isSelected,
  onSelect,
  updatePolygon,
  roleCode,
  ...rest
}) {
  const handleChange = (data) => {
    if (roleCode === "viewer") return;
    updatePolygon({
      ...data,
      dataPoint: data.points,
    });
  };

  return (
    <PolygonPrototype
      ratio={ratio}
      onSelect={onSelect}
      isSelected={isSelected}
      key={properties.id}
      polygon={{
        ...properties,
        points: properties.dataPoint.map((item) => [item.x, item.y]),
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

Polygon.propTypes = {
  properties: object,
  ratio: number,
  isSelected: bool,
  onSelect: func,
  updatePolygon: func,
  roleCode: string,
};

const mapStateToProps = () => (state) => ({
  roleCode: selectUserRole(state),
});

export default connect(mapStateToProps, { updatePolygon })(Polygon);
